import styled from "styled-components";
import {NavLink} from "react-router-dom";
import {withStyles} from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    height: 72px;
    padding: 0 24px;
    background: #FFFFFF;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    font-family: Mulish;
`;

export const Left = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;

export const BackBtn = styled.button`
    border: none;
    background: transparent;
    padding: 4px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #3C4657;
    font-size: 1.4rem;
    cursor: pointer;

    &:hover {
        color: #0080FC;
    }
`;

// Tooltip escuro (slate) do design, com seta — usado no botão de voltar.
export const BackTooltip = withStyles({
    tooltip: {
        backgroundColor: "#33475B",
        color: "#FFFFFF",
        fontFamily: "Mulish",
        fontSize: "0.8rem",
        fontWeight: 600,
        padding: "8px 12px",
        borderRadius: 8,
    },
    arrow: {
        color: "#33475B",
    },
})(Tooltip);

// Divisor vertical entre o botão de voltar e o logo (conforme o design).
export const Divider = styled.span`
    width: 1px;
    height: 32px;
    margin: 0 10px;
    background: #E6E9EF;
`;

export const Logo = styled.div`
    width: 46px;
    height: 46px;
    border-radius: 10px;
    background: #2BC0AD;
    color: #FFFFFF;
    font-weight: 800;
    font-size: 1.05rem;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const TitleBox = styled.div`
    display: flex;
    flex-direction: column;
    gap: 3px;
`;

export const Title = styled.span`
    font-weight: 700;
    color: #2B3240;
    font-size: 0.95rem;
    line-height: 1;
`;

export const Phone = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 9px 16px;
    background: #EEF1F6;
    border-radius: 22px;
    color: #4B5563;
    font-size: 0.85rem;
    font-weight: 600;

    svg {
        color: #0080FC;
    }
`;

// Indicador de conexão do número no chip do telefone: bolinha verde (conectado) / vermelha (desconectado) + texto.
export const Status = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 0.82rem;
    font-weight: 600;
    color: #6B7280;
`;
export const StatusDot = styled.span`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex: 0 0 auto;
    background: ${(p) => (p.$on ? "#22C55E" : "#EF4444")};
`;

export const Tabs = styled.nav`
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const Tab = styled(NavLink)`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 9px 16px;
    border-radius: 22px;
    color: #5B6472;
    text-decoration: none;
    font-weight: 600;
    font-size: 0.85rem;
    white-space: nowrap;
    transition: all .2s;

    svg {
        font-size: 1rem;
    }

    &:hover {
        color: #0080FC;
    }

    &.active {
        background: #E8F1FF;
        color: #2F80ED;
    }
`;

export const Badge = styled.span`
    background: #2F80ED;
    color: #FFFFFF;
    border-radius: 10px;
    padding: 1px 8px;
    font-size: 0.7rem;
    font-weight: 700;
`;

export const Right = styled.div`
    display: flex;
    align-items: center;
`;

export const MenuWrap = styled.div`
    position: relative;
`;

export const UserMenu = styled.button`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 5px 12px 5px 6px;
    border: none;
    border-radius: 26px;
    background: #F5F7FA;
    cursor: pointer;
    font-family: inherit;
`;

export const Dropdown = styled.div`
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    min-width: 180px;
    background: #FFFFFF;
    border: 1px solid #E6E9EF;
    border-radius: 10px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    padding: 6px;
    z-index: 20;
`;

export const DropdownItem = styled.button`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    background: transparent;
    border: none;
    border-radius: 8px;
    font-family: inherit;
    font-size: 0.85rem;
    font-weight: 600;
    color: #DC2626;
    cursor: pointer;
    text-align: left;

    &:hover {
        background: #FEF2F2;
    }
`;

export const Avatar = styled.div`
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #2BC0AD;
    color: #FFFFFF;
    font-weight: 700;
    font-size: 0.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const UserInfo = styled.div`
    display: flex;
    flex-direction: column;
    line-height: 1.15;
`;

export const UserName = styled.span`
    font-weight: 700;
    color: #2B3240;
    font-size: 0.85rem;
`;

export const UserRole = styled.span`
    font-size: 0.72rem;
    color: #8A94A6;
`;

export const Caret = styled.span`
    display: inline-flex;
    color: #8A94A6;
    font-size: 0.7rem;
`;
